import { render, staticRenderFns } from "./dyListimg_D.vue?vue&type=template&id=35d2e577&scoped=true"
import script from "./dyListimg_D.vue?vue&type=script&lang=js"
export * from "./dyListimg_D.vue?vue&type=script&lang=js"
import style0 from "./dyListimg_D.vue?vue&type=style&index=0&id=35d2e577&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d2e577",
  null
  
)

export default component.exports